/* eslint-disable camelcase */
import React, { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';

import Table from 'react-bootstrap/Table';

import ListingTemplate from '../../components/Template/ListingTemplate';
import Loader from '../../components/Loader';

import api from '../../services/api';

import { useToast } from '../../context/ToastContext';

import { IPermission } from '../../interfaces/IPermission';

interface PermissionDTO {
  permissions: IPermission;
}

interface UserFormDataDTO {
  id: number;
  name: string;
  nickname: string;
  username: string;
  is_admin: boolean;
  is_active: boolean;
}

/**
 * [X] Adicionar botão Editar
 * [ ] Corrigir a quebra de linha para texto muito grande
 */

const ReadsUsers: React.FC<PermissionDTO> = ({ permissions }) => {
  const [loading, setLoading] = useState(false);
  const [listUsers, setListUsers] = useState<UserFormDataDTO[]>([]);
  const [listUsersPaginatedItems, setListUsersPaginatedItems] = useState<any[]>(
    [],
  );
  const { addToast } = useToast();

  useEffect(() => {
    try {
      const getListUsers = async (): Promise<void> => {
        try {
          setLoading(true);
          const response = await api.get('users');
          setListUsers(response.data);
          setLoading(false);
        } catch (error) {
          setLoading(false);
          // eslint-disable-next-line no-shadow
          if (error.response) {
            const { data } = error.response; // Error vindo do back está em data dentro de response
            addToast({
              type: 'error',
              title: data.message,
            });
            return;
          }

          addToast({
            type: 'error',
            title: 'Ocorreu um erro interno',
          });
        }
      };
      getListUsers();
    } catch (error) {
      setLoading(false);
      // eslint-disable-next-line no-shadow
      if (error.response.data) {
        const { data } = error.response; // Error vindo do back está em data dentro de response
        addToast({
          type: 'error',
          title: data.message,
        });
        return;
      }

      addToast({
        type: 'error',
        title: 'Ocorreu um erro interno',
      });
    }
  }, [addToast]);

  const handleListUsersPaginatedItems = useCallback(newList => {
    setListUsersPaginatedItems(newList);
  }, []);

  return (
    <ListingTemplate
      title="Usuários"
      module="users"
      listItemsProps={listUsers}
      handleListItemsPaginatedItems={handleListUsersPaginatedItems}
      placeHolderProp="Cód. do Usuário"
      permissions={permissions}
    >
      {(loading && <Loader />) || (
        <>
          <Table striped bordered hover size="sm" responsive="md">
            <thead className="text-center text-primary text-uppercase">
              <tr>
                <th className="font-weight-normal py-3" scope="col">
                  ID
                </th>
                <th className="font-weight-normal py-3" scope="col">
                  Nome
                </th>
                <th className="font-weight-normal py-3" scope="col">
                  Nickname
                </th>
                <th className="font-weight-normal py-3" scope="col">
                  Username
                </th>
                <th className="font-weight-normal py-3" scope="col">
                  Nível Administrador
                </th>
                <th className="font-weight-normal py-3" scope="col">
                  Usuário Ativo
                </th>
                <th className="font-weight-normal py-3" scope="col">
                  Ações
                </th>
              </tr>
            </thead>
            <tbody className="text-center">
              {listUsersPaginatedItems.map((item, index) => (
                <tr key={index.toString()}>
                  <th scope="row">{item.id}</th>
                  <td className="text-left">{item.name}</td>
                  <td>{item.nickname}</td>
                  <td>{item.username}</td>
                  <td>{(item.is_admin === true && ' SIM') || ' NÃO'}</td>
                  <td>{(item.is_active === true && ' SIM') || ' NÃO'}</td>
                  <td>
                    {(permissions.update && (
                      <Link to={`/users/read/${item.id}`}>Alterar</Link>
                    )) || <span className="text-cinza-51-5bits">Alterar</span>}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </>
      )}
    </ListingTemplate>
  );
};

export default ReadsUsers;
